<template>
    <card class="card">
        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-cogs text-primary"></i> {{$t('part.titleadd')}}
            </h2>
            <hr />
            <div>
                <form @submit.prevent>
                    <div class="row">
                        <div class="col-md-6">
                            <fg-input type="text" :label="$t('part.name')" v-model="form.part.name"></fg-input>
                        </div>
                         <div class="col-md-6">
                            <fg-input type="text" label="NCM" v-model="form.part.ncm"></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('part.sku')"
                                placeholder="SKU"
                                v-model="form.part.sku"
                            ></fg-input>
                        </div>
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('part.code')"
                                placeholder="Code"
                                v-model="form.part.code"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="information">{{$t('part.information')}}</label>
                                <textarea class="form-control" v-model="form.part.information"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label for>{{$t('part.productimage')}}</label>
                            <b-form-file
                                accept="image/png, image/jpeg, image/jpg"
                                v-model="form.product_images"
                                :placeholder="$t('part.text.chooseafile')"
                            ></b-form-file>
                            <small
                                class="text-muted"
                            >{{$t('part.text.allowedfiletypesimage')}}</small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="typo__label">{{$t('part.category')}}</label>
                            <multiselect
                                v-model="category_value"
                                :options="categories"
                                :multiple="true"
                                :placeholder="$t('part.text.selectone')"
                                label="name"
                                track-by="id"
                                :hide-selected="true"
                                @input="selectCategory"
                            ></multiselect>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('part.price')"
                                placeholder="Price"
                                v-model="form.part.price"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h4 for>{{$t('part.visibility')}}</h4>
                            <!-- Admin -->
                            <b-form-checkbox
                                v-model="form.part.visible.user.admin.checked"
                                :value="true"
                                :unchecked-value="false"
                            >{{$t('part.admin')}}</b-form-checkbox>
                            <br />
                            <div
                                class="border rounded p-4 my-4"
                                v-if="form.part.visible.user.admin.checked"
                            >
                                <h5 class="text-muted">{{$t('part.pages')}}</h5>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.admin.page.repair_status.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >{{$t('part.repairstatus')}}</b-form-checkbox>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.admin.page.requests.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >{{$t('part.requests')}}</b-form-checkbox>

                                <div v-if="form.part.visible.user.admin.page.repair_status.checked">
                                    <h5 class="text-muted">{{$t('part.repairstatuspagebuttons')}}</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.admin.page.repair_status.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>

                                <div v-if="form.part.visible.user.admin.page.requests.checked">
                                    <h5 class="text-muted">{{$t('part.requestspagebuttons')}}</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.admin.page.requests.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>
                            </div>

                            <!-- END Admin -->

                            <!-- ASF  -->
                            <b-form-checkbox
                                v-model="form.part.visible.user.asf.checked"
                                :value="true"
                                :unchecked-value="false"
                            >{{$t('part.asfadmin')}}</b-form-checkbox>
                            <br />
                            <div
                                class="border rounded p-4 my-4"
                                v-if="form.part.visible.user.asf.checked"
                            >
                                <h5 class="text-muted">{{$t('part.pages')}}</h5>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.asf.page.repair_status.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >{{$t('part.repairstatus')}}</b-form-checkbox>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.asf.page.requests.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >{{$t('part.requests')}}</b-form-checkbox>

                                <div v-if="form.part.visible.user.asf.page.repair_status.checked">
                                    <h5 class="text-muted">{{$t('part.repairstatuspagebuttons')}}</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.asf.page.repair_status.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>
                                <div v-if="form.part.visible.user.asf.page.requests.checked">
                                    <h5 class="text-muted">{{$t('part.requestspagebuttons')}}</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.asf.page.requests.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>
                            </div>
                            <!-- END ASF -->

                            <!-- ASF Admin -->
                            <!-- <b-form-checkbox
                                v-model="form.part.visible.user.asf_admin.checked"
                                :value="true"
                                :unchecked-value="false"
                            >Asf Admin</b-form-checkbox>
                            <br />
                            <div
                                class="border rounded p-4 my-4"
                                v-if="form.part.visible.user.asf_admin.checked"
                            >
                                <h5 class="text-muted">Pages</h5>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.asf_admin.page.repair_status.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >Repair Status</b-form-checkbox>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.asf_admin.page.requests.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >Requests</b-form-checkbox>

                                <div
                                    v-if="form.part.visible.user.asf_admin.page.repair_status.checked"
                                >
                                    <h5 class="text-muted">Repair Status Page Buttons</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.asf_admin.page.repair_status.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>
                                <div v-if="form.part.visible.user.asf_admin.page.requests.checked">
                                    <h5 class="text-muted">Request Page Buttons</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.asf_admin.page.requests.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>
                            </div>-->
                            <!-- END ASF Admin -->

                            <!-- ASF Technician Admin -->
                            <!-- <b-form-checkbox
                                v-model="form.part.visible.user.asf_technician.checked"
                                :value="true"
                                :unchecked-value="false"
                            >Asf Technician</b-form-checkbox>
                            <br />
                            <div
                                class="border rounded p-4 my-4"
                                v-if="form.part.visible.user.asf_technician.checked"
                            >
                                <h5 class="text-muted">Pages</h5>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.asf_technician.page.repair_status.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >Repair Status</b-form-checkbox>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.asf_technician.page.requests.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >Requests</b-form-checkbox>

                                <div
                                    v-if="form.part.visible.user.asf_technician.page.repair_status.checked"
                                >
                                    <h5 class="text-muted">Repair Status Page Buttons</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.asf_technician.page.repair_status.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>
                                <div
                                    v-if="form.part.visible.user.asf_technician.page.requests.checked"
                                >
                                    <h5 class="text-muted">Request Page Buttons</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.asf_technician.page.requests.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>
                            </div>-->
                            <!-- END ASF Technician Admin -->

                            <!-- ASF Frontdesk Admin -->
                            <!-- <b-form-checkbox
                                v-model="form.part.visible.user.asf_frontdesk.checked"
                                :value="true"
                                :unchecked-value="false"
                            >Asf Frontdesk</b-form-checkbox>
                            <br />
                            <div
                                class="border rounded p-4 my-4"
                                v-if="form.part.visible.user.asf_frontdesk.checked"
                            >
                                <h5 class="text-muted">Pages</h5>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.asf_frontdesk.page.repair_status.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >Repair Status</b-form-checkbox>
                                <b-form-checkbox
                                    class="mb-4"
                                    v-model="form.part.visible.user.asf_frontdesk.page.requests.checked"
                                    :value="true"
                                    :unchecked-value="false"
                                >Requests</b-form-checkbox>

                                <div
                                    v-if="form.part.visible.user.asf_frontdesk.page.repair_status.checked"
                                >
                                    <h5 class="text-muted">Repair Status Page Buttons</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.asf_frontdesk.page.repair_status.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>
                                <div
                                    v-if="form.part.visible.user.asf_frontdesk.page.requests.checked"
                                >
                                    <h5 class="text-muted">Request Page Buttons</h5>
                                    <b-form-checkbox-group
                                        class="mb-4"
                                        v-model="form.part.visible.user.asf_frontdesk.page.requests.buttons"
                                        :options="buttons"
                                    ></b-form-checkbox-group>
                                </div>
                            </div>-->
                            <!-- END ASF Frontdesk Admin -->
                        </div>
                    </div>
                    <div class="text-left">
                        <p-button type="primary" @click.native.prevent="save">{{$t('part.button.save')}}</p-button>
                    </div>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
    </card>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      category_value: null,
      buttons: [
        { text: this.$t('part.buy'), value: "buy" },
        { text: this.$t('part.fromstock'), value: "from_stock" },
        { text: this.$t('part.earlykit'), value: "early_kit" },
        { text: this.$t('part.inwarranty'), value: "in_warranty" },
        { text: this.$t('part.cannibalization'), value: "canabalization" }
      ],
      form: {
        product_images: "",
        part: {
          name: "",
          sku: "",
          code: "",
          categories: [],
          price: "",
          information: "",
          ncm: "",
          visible: {
            user: {
              admin: {
                checked: false,
                page: {
                  repair_status: {
                    checked: false,
                    buttons: []
                  },
                  requests: {
                    checked: false,
                    buttons: []
                  }
                }
              },
              asf: {
                checked: false,
                page: {
                  checked: false,
                  repair_status: {
                    checked: false,
                    buttons: []
                  },
                  requests: {
                    checked: false,
                    buttons: []
                  }
                }
              }
              // asf_admin: {
              //   checked: false,
              //   page: {
              //     checked: false,
              //     repair_status: {
              //       checked: false,
              //       buttons: []
              //     },
              //     requests: {
              //       checked: false,
              //       buttons: []
              //     }
              //   }
              // },
              // asf_frontdesk: {
              //   checked: false,
              //   page: {
              //     checked: false,
              //     repair_status: {
              //       checked: false,
              //       buttons: []
              //     },
              //     requests: {
              //       checked: false,
              //       buttons: []
              //     }
              //   }
              // },
              // asf_technician: {
              //   checked: false,
              //   page: {
              //     checked: false,
              //     repair_status: {
              //       checked: false,
              //       buttons: []
              //     },
              //     requests: {
              //       checked: false,
              //       buttons: []
              //     }
              //   }
              // }
            }
          }
        }
      }
    };
  },
  computed: {
    categories() {
      return this.$store.getters["parts/getCategories"];
    }
  },
  methods: {
    selectCategory(option) {
      this.form.part.categories = [];
      option.forEach(item => {
        this.form.part.categories.push(item.id);
      });
    },
    save() {
      this.$store.commit("parts/set", this.form);
      this.$store
        .dispatch("parts/add", this.form)
        .then(response => {
          this.$notify({
            type: "success",
            horizontalAlign: "center",
            message: "Part added with success!"
          });
          this.$router.push({
            name: "parts_edit",
            params: { id: response.data.id }
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  },
  created() {
    this.$store.dispatch("parts/getCategories");
  }
};
</script>
<style>
</style>
